














import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Modal extends Vue {
  @Prop() private title!: string;
  public name = '';
  public mounted() {
    const input = document.getElementById('selectNameInput');
    if (input) {
      input.focus();
    }
  }

  public completed() {
    this.$emit('completed', this.name);
  }
}
